<template>
  <div class="misc-wrapper">
    <!-- Brand logo-->
    <b-link class="brand-logo">
      <b-img
        :src="appLogoImageUrl"
        rounded="circle"
        alt="logo"
      />
    </b-link>
    <!-- /Brand logo-->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('full.not-authorized') }}
        </h2>
        <!-- <p class="mb-2">
          {{ $t('full.not-authorized_subtitle') }}
        </p> -->
        <b-card-text class="text-center mt-1">
          <span>{{ $t('full.login-problem-more') }}</span>
          <b-link :to="{name:'logout'}">
            <span>&nbsp;{{ $t('common.click-here') }}</span>
          </b-link>
        </b-card-text>
        <b-button
          variant="primary"
          class="btn-sm-block"
          :to="{name:'login'}"
        >{{ $t('full.not-authorized_back') }}</b-button>

        <b-img
          fluid
          :src="imgUrl"
          class="mt-1"
          alt="Not authorized page"
        />
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BImg, BButton, BCardText,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import store from '@/store/index'

const { appName, appLogoImageUrl } = $themeConfig.app

export default {
  components: {
    BLink, BImg, BButton, BCardText,
  },
  data() {
    return {
      appName,
      appLogoImageUrl,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return require('@/assets/images/pages/not-authorized-dark.svg')
      } return require('@/assets/images/pages/not-authorized.svg')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
